<div class="i-page-top">
  <div class="container">
    <!--Menu-->
    <div class="i-menu row align-items-center pt-3 pb-2">
      <div class="navbar-brand col-6 col-sm-8 col-md-6 col-lg-4 mr-auto py-2 px-0 text-center text-sm-left">
        <a href="#" routerLink="/home" aria-label="Private"
          ><img src="assets/img/logo_cinza.svg" class="img-fluid my-auto" alt="Private"
        /></a>
      </div>
      <div class="col-6 col-sm-4 col-md-6 col-lg-8 ml-auto py-2">
        <app-menu></app-menu>
      </div>
    </div>
  </div>
</div>
<div class="i-page-content">
  <!--Call-Text-->
  <div
    class="i-main-call mt-3 py-5"
    [style]="
      'background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(' +
      (this.banner$ | async)?.arquivoUrl +
      ');'
    ">
    <div class="container py-4 px-0">
      <div class="col-12 text-left px-2 px-lg-5 py-3">O MELHOR LUGAR PARA A SUA EMPRESA CRESCER.</div>
      <div class="i-subtitle col-12 col-md-7 text-left px-2 px-lg-5">
        Com clientes como as Lojas Lebes, Deloitte e mais, nosso time corporate é focado em soluções em aluguel e venda
        para grandes unidades corporativas.
        <br />
        <a data-toggle="modal" data-target="#modal_corporate" class="btn btn-outline-light mt-4">CONHEÇA MAIS</a>
      </div>
    </div>
  </div>
  <div class="i-favorite container py-5">
    <div class="row text-center py-5">
      <h1 class="i-title mx-auto">
        IMÓVEIS CORPORATE
        <ng-container *ngIf="search?.cidadeNome">
          <br />
          <div class="mt-4">
            {{ search?.cidadeNome }}
          </div>
        </ng-container>
      </h1>
    </div>
    <!-- BUSCA -->
    <div class="row justify-content-between pb-5">
      <app-form-busca
        [(search)]="search"
        (changeSearch)="onChangeRoute($event)"
        [enableSticky]="true"
        [enableAdvanced]="false"></app-form-busca>
    </div>
    <!-- -->
    <ng-container *ngIf="this.imoveis$ | async as resultPage">
      <ng-container *ngIf="resultPage?.items?.length > 0; else empty">
        <div class="row no-gutters">
          <div
            *ngFor="
              let property of resultPage.items
                | paginate
                  : {
                      id: 'pagination',
                      itemsPerPage: resultPage?.size,
                      currentPage: search.pag,
                      totalItems: resultPage?.total,
                    }
            "
            class="col-12 p-4">
            <app-box [property]="property" [boxType]="BoxType.Detail" [showMoreLessButton]="false"></app-box>
          </div>
        </div>
        <!--Pagination-->
        <div class="i-pagination row justify-content-center flex-column pt-3 pb-5">
          <pagination-controls
            (pageChange)="onChangePage($event)"
            id="pagination"
            class="mx-auto"
            [directionLinks]="false">
          </pagination-controls>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #empty>
      <div class="col i-text text-center my-3 py-5">
        <!-- SEM REGISTROS -->
        <h2 class="mb-2">Não há imóveis nesta categoria.</h2>
        Vá para busca e encontre o imóvei ideal para você.

        <div class="d-block mt-5">
          <a href="#" routerLink="/imoveis/status/venda" class="i-btn">Buscar imóveis</a>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<!-- Modal -->
<div class="modal fade p-0" id="modal_corporate" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
  <div class="i-modal-bg">
    <div class="modal-dialog mt-0" role="document">
      <div class="modal-content">
        <div class="row">
          <div class="i-title col-12 text-left">O MELHOR LUGAR PARA A SUA EMPRESA CRESCER.</div>
          <div class="i-subtitle col-12 text-left pt-3 px-lg-5">
            <div class="i-hr"></div>
            Com clientes como as Lojas Lebes, Deloitte e mais, nosso time corporate é focado em soluções em aluguel e
            venda para grandes unidades corporativas.<br />
            <br />
            <b>Quem conhece, confia:</b> Grandes empresas confiam nos nossos serviços corporativos, entre elas Deloitte
            Touche Tomatsu, Lebes, Thomsom Reuters, CVC Turismo, Detran-RS, Kia Sun Motors e Becomex.<br />
            <br />
            <b>Experiência para fazer os melhores negócios:</b> Nosso time de especialistas corporate conta com décadas
            de experiência no setor - garantindo tranquilidade para você e sua empresa.<br />
            <br />
            <b>Qualidade Private Imóveis:</b> Assim como em todos os nossos serviços, você pode contar com nosso
            atendimento especializado de alto nível no Corporate.
          </div>
          <div class="col-12">
            <div class="i-hr"></div>
          </div>
          <div class="px-2 px-lg-5">
            <button type="submit" class="i-btn" data-dismiss="modal">VOLTAR</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
